import React, { useState, useEffect } from 'react';
import { useApp } from '../../context/AppContext';

function useMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return isMobile;
}

const NAV_CONFIG = {
  admin: [
    { sec: 'Dashboard' },
    { id: 'dashboard', label: 'Overview', icon: '▦' },
    { sec: 'Admin Tools' },
    { id: 'approvals', label: 'Approvals', icon: '✓', badge: true },
    { id: 'admin-users', label: 'Users', icon: '👤' },
    { id: 'admin-customers', label: 'Companies', icon: '👥' },
    { id: 'admin-vessels', label: 'Vessels', icon: '🚢' },
    { id: 'admin-suppliers', label: 'Suppliers', icon: '🏭' },
    { id: 'admin-masters', label: 'Configurations', icon: '⚙' },
    { sec: 'Warehouse' },
    { id: 'stock-list', label: 'Stock List', icon: '📋' },
    { id: 'delivery', label: 'Delivery Orders', icon: '🚚' },
    { id: 'fleet', label: 'Fleet Management', icon: '🚛' },
  ],
  warehouse: [
    { sec: 'Dashboard' },
    { id: 'dashboard', label: 'Overview', icon: '▦' },
    { sec: 'Operations' },
    { id: 'stock-list', label: 'Stock List', icon: '📋' },
    { id: 'delivery', label: 'Delivery Orders', icon: '🚚' },
    { id: 'fleet', label: 'Fleet Management', icon: '🚛' },
  ],
  customer: [
    { sec: 'My Account' },
    { id: 'my-stock', label: 'Stock List', icon: '📦' },
    { id: 'my-deliveries', label: 'Delivery Orders', icon: '🚚' },
  ],
  fleet_controller: [
    { sec: 'Operations' },
    { id: 'fleet', label: 'Fleet Management', icon: '🚛' },
  ],
};

export default function Sidebar({ current, onNav, onLogout, loggedUser, isOpen, onClose }) {
  const { role, pendingStock } = useApp();
  const nav = NAV_CONFIG[role] || NAV_CONFIG.admin;
  const isMobile = useMobile();

  const handleNav = (id) => {
    onNav(id);
    if (isMobile) onClose();
  };

  const sidebarStyle = isMobile ? {
    position: 'fixed', top: 0, left: 0, zIndex: 999,
    width: 256, background: 'var(--white)', borderRight: '1px solid var(--border)',
    height: '100vh', display: 'flex', flexDirection: 'column', flexShrink: 0, overflowY: 'auto',
    transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
    transition: 'transform .25s ease',
    boxShadow: isOpen ? 'var(--shadow-lg)' : 'none',
  } : {
    width: 256, background: 'var(--white)', borderRight: '1px solid var(--border)',
    height: '100vh', display: 'flex', flexDirection: 'column', flexShrink: 0, overflowY: 'auto',
  };

  return (
    <>
      {isMobile && isOpen && (
        <div className="sidebar-backdrop" onClick={onClose} />
      )}
    <aside style={sidebarStyle}>

      {/* Logo */}
      <div style={{
        padding: '20px 18px 16px', borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', gap: 10
      }}>
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Allin Logistics" style={{ width: 42, height: 42, objectFit: 'contain' }} />
        <div>
          <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--text)', letterSpacing: '-.4px' }}>ALL IN LOGISTICS</div>
          <div style={{ fontSize: 10, color: 'var(--muted)', fontWeight: 500, letterSpacing: '.5px', textTransform: 'uppercase' }}>Warehouse System</div>
        </div>
      </div>

      {/* Role Switcher Removed */}

      {/* Nav */}
      <div style={{ flex: 1 }}>
        {nav.map((item, i) =>
          item.sec
            ? <div key={i} style={{
              padding: '14px 16px 5px', fontSize: 10, fontWeight: 700,
              color: 'var(--muted2)', textTransform: 'uppercase', letterSpacing: '1.2px'
            }}>{item.sec}</div>
            : <NavItem key={item.id} item={item} active={current === item.id}
              onNav={handleNav} badge={item.badge ? pendingStock.length : 0} />
        )}
      </div>
    </aside>
    </>
  );
}

function NavItem({ item, active, onNav, badge }) {
  return (
    <div onClick={() => onNav(item.id)}
      style={{
        margin: '1px 8px', padding: '8px 10px', borderRadius: 7, display: 'flex',
        alignItems: 'center', gap: 9, cursor: 'pointer', fontSize: 13.5,
        fontWeight: active ? 600 : 500,
        color: active ? 'var(--accent)' : 'var(--text2)',
        background: active ? 'var(--accent-light)' : 'transparent',
        transition: 'all .15s'
      }}
      onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'var(--surface2)'; }}
      onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}>
      <span style={{ fontSize: 15 }}>{item.icon}</span>
      <span style={{ flex: 1 }}>{item.label}</span>
      {badge > 0 && (
        <span style={{
          background: 'var(--danger)', color: '#fff', fontSize: 10, fontWeight: 700,
          minWidth: 18, height: 18, borderRadius: 9, display: 'flex', alignItems: 'center',
          justifyContent: 'center', padding: '0 4px'
        }}>
          {badge}
        </span>
      )}
    </div>
  );
}
